import { useMemo } from "react";

interface CfAccessUser {
  email?: string;
  name?: string;
  sub?: string;
}

function parseCfAccessJwt(): CfAccessUser | null {
  try {
    const cookies = document.cookie.split(";").map((c) => c.trim());
    const cfCookie = cookies.find((c) => c.startsWith("CF_Authorization="));
    if (!cfCookie) return null;

    const token = cfCookie.split("=")[1];
    if (!token) return null;
    const payload = token.split(".")[1];
    if (!payload) return null;
    const decoded = JSON.parse(atob(payload));

    return {
      email: decoded.email,
      name: decoded.name || decoded.email?.split("@")[0],
      sub: decoded.sub,
    };
  } catch {
    return null;
  }
}

export function useAuth() {
  const user = useMemo(() => parseCfAccessJwt(), []);
  return { user, isAuthenticated: !!user };
}
